import { userPropertiesManagementApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const USER_PROPERTIES_MANAGEMENT_ACTIONS = createNamedActions('userPropertiesManagement', {
  GET_USER_PROPERTIES: 'GET_USER_PROPERTIES',
  ADD_USER_PROPERTY: 'ADD_USER_PROPERTY',
  EDIT_USER_PROPERTY: 'EDIT_USER_PROPERTY',
  DELETE_USER_PROPERTY: 'DELETE_USER_PROPERTY',
});

export const getUserPropertiesAction = catchAsyncActionError(props => async dispatch => {
  const { data } = await userPropertiesManagementApi.getUserProperties(props);

  return dispatch({
    type: USER_PROPERTIES_MANAGEMENT_ACTIONS.GET_USER_PROPERTIES,
    payload: data,
  });
});

export const editUserPropertyAction = catchAsyncActionError(
  ({ isEdit, ...props }) =>
    async dispatch => {
      const { data } = await userPropertiesManagementApi.editUserProperty(props);

      return dispatch({
        type: isEdit
          ? USER_PROPERTIES_MANAGEMENT_ACTIONS.EDIT_USER_PROPERTY
          : USER_PROPERTIES_MANAGEMENT_ACTIONS.ADD_USER_PROPERTY,
        payload: data,
      });
    },
);

export const deleteUserPropertyAction = catchAsyncActionError(props => async dispatch => {
  await userPropertiesManagementApi.deleteUserProperty(props);

  return dispatch({
    type: USER_PROPERTIES_MANAGEMENT_ACTIONS.DELETE_USER_PROPERTY,
    meta: props,
  });
});
